<template>
  <div class="main_tabs">
    <div class="location">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item> 监控中心 </el-breadcrumb-item>
        <el-breadcrumb-item>设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>设备详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-tabs
      class="current_time_tabs"
      v-model="activeName"
      @tab-click="handleClick"
      type="card"
    >
      <el-tab-pane label="首页" v-if="tabList.Home" name="first">
        <div class="current_time">{{ currentTime }}</div>
        <div class="mainbody" v-if="activeName == 'first'">
          <div class="details_infor_left">
            <el-card class="card_margin_bottom">
              <div class="card_div_margin">
                <p style="margin-bottom: 40px; font-weight: 600">
                  <span
                    class="card_status"
                    :style="{ background: onlineColor[indexDate1.online] }"
                    >{{ indexDate1.online == 1 ? "在线" : "离线" }}</span
                  >
                  <span
                    >{{ indexDate1.companyName || "" }} |
                    {{ indexDate1.cabinetCode || "" }}</span
                  >
                  <span
                    class="crad_status_circle"
                    v-if="indexDate1.state == 1"
                    style="background: #909399"
                  ></span>
                  <span
                    class="crad_status_circle"
                    v-else-if="indexDate1.state == 3"
                    style="background: red"
                  ></span>
                  <span
                    class="crad_status_circle"
                    v-else
                    style="background: #67c23a"
                  ></span>
                </p>
                <p>
                  <span>电量 </span
                  ><span class="soc_schedule"
                    ><p :style="{ width: (indexDate1.soc || 0) + '%' }"></p
                  ></span>
                  {{ indexDate1.soc || 0 }} %
                </p>
                <p>
                  {{ stateType[indexDate1.state || 1] }}
                  <span v-if="indexDate1.state == 3">{{
                    indexDate1.alarmCodeName || ""
                  }}</span>
                  【{{ indexBattery.customChargePower || 0 }} KW】
                </p>
                <p>
                  <span
                    >最高温度 {{ indexBattery.maxTemp || 0 }} °c
                    &nbsp;&nbsp;&nbsp;&nbsp;</span
                  ><span> 最低温度 {{ indexBattery.minTemp || 0 }} °c</span>
                </p>
                <p>
                  <span
                    >最高电压 {{ indexBattery.maxSingleVoltage || 0 }} mv
                    &nbsp;&nbsp;&nbsp;&nbsp;</span
                  ><span>
                    最低电压 {{ indexBattery.minSingleVoltage || 0 }} mv</span
                  >
                </p>
              </div>
            </el-card>
            <el-card class="card_margin_bottom">
              <div>
                <p style="font-weight: 600">各电池簇电量</p>
                <ul class="battery" style="min-height: 176px; overflow: hidden">
                  <li v-for="(item, index) in bmsModels" :key="index">
                    <span>{{ item.tag || index }} </span
                    ><span
                      :class="item.faultState == 0 ? 'schedule' : 'schedule1'"
                      ><p
                        class="schedule_c"
                        :style="{ width: (item.soc || 0) + '%' }"
                      ></p>
                    </span>

                    {{ item.soc || 0 }} %
                    <i
                      :class="
                        item.isEnable == 0 ? 'el-icon-error' : 'el-icon-success'
                      "
                      :style="
                        item.isEnable == 0 ? 'color: red' : 'color: green'
                      "
                    ></i>
                    <div style="position: absolute; top: 20px">
                      <el-tag
                        size="mini"
                        style="margin-right: 5px"
                        v-for="alarm in getAlarmValues(item.alarms)"
                        :key="alarm.id"
                        :type="alarm.type"
                        >{{ alarm.value }}</el-tag
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </el-card>
            <el-card>
              <div class="tabs_day_mounth" style="padding: 0 20px 20px 20px">
                <p style="font-weight: 600; text-align: left; cursor: pointer">
                  <el-tabs v-model="chageName" @tab-click="chageDayMonth">
                    <el-tab-pane
                      label="本月统计"
                      size="mini"
                      name="monuth"
                    ></el-tab-pane>
                    <el-tab-pane
                      label="本日统计"
                      size="mini"
                      name="day"
                    ></el-tab-pane>
                    <el-tab-pane
                      label="跟随"
                      size="mini"
                      name="currentSearch"
                    ></el-tab-pane>
                  </el-tabs>
                </p>
                <ul class="statistics">
                  <li>
                    <span>时段</span>
                    <span>充电</span>
                    <span>放电</span>
                  </li>
                  <li>
                    <span>高尖</span
                    ><span>{{ indexDate.highTopChargePower || 0 }}</span
                    ><span>{{ indexDate.highTopDischargePower || 0 }}</span>
                  </li>
                  <li>
                    <span>尖</span
                    ><span>{{ indexDate.topChargePower || 0 }}</span
                    ><span>{{ indexDate.topDischargePower || 0 }}</span>
                  </li>
                  <li>
                    <span>峰</span
                    ><span>{{ indexDate.peakChargePower || 0 }}</span
                    ><span>{{ indexDate.peakDischargePower || 0 }}</span>
                  </li>
                  <li>
                    <span>平</span
                    ><span>{{ indexDate.flatChargePower || 0 }}</span
                    ><span>{{ indexDate.flatDischargePower || 0 }}</span>
                  </li>
                  <li>
                    <span>谷</span
                    ><span>{{ indexDate.valleyChargePower || 0 }}</span
                    ><span>{{ indexDate.valleyDischargePower || 0 }}</span>
                  </li>
                  <li>
                    <span>总计</span
                    ><span>{{ indexDate.totalChargePower || 0 }}</span
                    ><span>{{ indexDate.totalDischargePower || 0 }}</span>
                  </li>
                </ul>
              </div>
              <div style="display: flex; justify-content: space-around">
                <el-link :underline="false" @click="toggleChageR()"
                  >日报</el-link
                >
                <el-link :underline="false" @click="toggleChageY()"
                  >月报</el-link
                >
                <el-link :underline="false" @click="toggleChage()"
                  >充放订单</el-link
                >
              </div>
            </el-card>
          </div>
          <div class="details_infor_right">
            <el-card
              class="card_margin_bottom card_pic card_bg_1"
              :class="{
                card_bg_1: indexDate1.state == 3,
                card_bg_2: indexDate1.state == 1,
                card_bg_3: indexDate1.state == 4,
                card_bg_4: indexDate1.state == 5,
              }"
            >
              <span class="span_pic_1">
                <p>
                  <b class="font_w600">PCS</b
                  ><i
                    :class="[
                      indexBattery.connectPcsState == 0
                        ? 'el-icon-close'
                        : 'el-icon-check',
                    ]"
                  ></i>
                </p>
                <p>电压 {{ indexBattery.pcsVoltage || 0 }} V</p>
                <p>功率 {{ indexBattery.pcsPower || 0 }} KW</p>
                <p>
                  电表
                  <i
                    :class="[
                      indexBattery.connectDevAmmeterState == 0
                        ? 'el-icon-close'
                        : 'el-icon-check',
                    ]"
                  ></i>
                </p>
                <p>功率 {{ indexBattery.ammDevicePower || 0 }} KW</p>
              </span>
              <span class="span_pic_2">
                <p class="font_w600">配电系统</p>
                <p>
                  电表状态
                  <i
                    :class="[
                      indexBattery.connectUserAmmeterState == 0
                        ? 'el-icon-close'
                        : 'el-icon-check',
                    ]"
                  ></i>
                </p>
                <p>电表功率 {{ indexBattery.ammUserPower || 0 }} KW</p>
              </span>
              <span class="span_pic_3">
                <p class="font_w600">电网</p>
                <p>剩余功率 {{ indexBattery.disposablePower || 0 }} KW</p>
                <p>输出功率 {{ indexBattery.outputPower || 0 }} KW</p>
              </span>
              <span class="span_pic_4">
                <p class="font_w600">用户负载</p>
                <p>负载功率 {{ indexBattery.userAmmActualPower || 0 }} KW</p>
              </span>
              <span class="span_pic_5">
                <p>
                  <b class="font_w600">BMS</b>
                  <i
                    :class="[
                      indexBattery.connectBmsState == 0
                        ? 'el-icon-close'
                        : 'el-icon-check',
                    ]"
                  ></i>
                </p>
                <p>电压 {{ indexBattery.bmsVoltage || 0 }} V</p>
                <p>功率 {{ indexBattery.bmsPower || 0 }} KW</p>
                <p>电流 {{ indexBattery.bmsCurrent || 0 }} A</p>
                <p>SOC {{ indexBattery.bmsSoc || 0 }} %</p>
                <p>SOH {{ indexBattery.bmsSoh || 0 }} %</p>
              </span>
            </el-card>
            <el-card class="card_padding">
              <div class="chage_day_month">
                <span class="day_month_span" v-show="dayMouth">日统计数据</span>
                <span class="day_month_span" v-show="!dayMouth"
                  >月统计数据</span
                >
                <el-date-picker
                  v-show="dayMouth"
                  v-model="firstDay"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>

                <el-date-picker
                  v-show="!dayMouth"
                  v-model="lastMonth"
                  type="monthrange"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  :picker-options="pickerOptions"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                >
                </el-date-picker>
                <span
                  class="day_month_span day_month_span_click"
                  @click="chageDayMou"
                  >日月统计切换</span
                >
                <span
                  class="day_month_span day_month_span_serch"
                  @click="dayMonthSerch"
                  >搜索</span
                >
              </div>
            </el-card>
            <el-card v-show="dayMouth">
              <div class="ibtn-box">
                <div
                  id="dailyChart"
                  style="height: 282px; margin-top: 20px"
                ></div>
              </div>
            </el-card>
            <el-card v-show="!dayMouth">
              <div class="ibtn-box">
                <div
                  id="monthlyChart"
                  style="height: 282px; margin-top: 20px"
                ></div>
              </div>
            </el-card>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-if="fx_login_companyType == 0 && tabList.BMS"
        label="BMS"
        name="second"
      >
        <bms v-if="activeName == 'second'"></bms>
      </el-tab-pane>
      <el-tab-pane
        v-if="fx_login_companyType == 0 && tabList.PCS"
        label="PCS"
        name="third"
      >
        <pcs v-if="activeName == 'third'"></pcs>
      </el-tab-pane>
      <el-tab-pane
        v-if="fx_login_companyType == 0 && tabList.Cell"
        label="电芯"
        name="fourth"
      >
        <cell v-if="activeName == 'fourth'"></cell>
      </el-tab-pane>
      <el-tab-pane
        v-if="fx_login_companyType == 0 && tabList.Distribute"
        label="参数下发"
        name="five"
      >
        <distribute v-if="activeName == 'five'"></distribute>
      </el-tab-pane>
      <el-tab-pane label="操作设备" name="sex" v-if="flagInstruct">
        <operateDevice v-if="activeName == 'sex'"></operateDevice>
      </el-tab-pane>
      <el-tab-pane label="功率曲线" name="seven" v-if="flagInstruct">
        <powerCurve v-if="activeName == 'seven'"></powerCurve>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import * as echarts from "echarts"; //eslint-disable-line no-unused-vars
// import "echarts/map/js/china"; // 引入中国地图数据
import { AxiosAjax, addDate, addMonth } from "../../js/axios.config";
import Bms from "@/components/Monitor/Bms.vue";
import Pcs from "@/components/Monitor/Pcs.vue";
import Cell from "@/components/Monitor/Cell.vue";
import Distribute from "@/components/Monitor/Distribute.vue";
import OperateDevice from "@/components/Monitor/OperateDevice.vue";
import PowerCurve from "@/components/Monitor/PowerCurve.vue";

export default {
  components: {
    Bms,
    Pcs,
    Cell,
    Distribute,
    OperateDevice,
    PowerCurve,
  },
  data() {
    return {
      currentTime: "",
      chageName: "monuth",
      activeName: "first",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      echartList: [],
      dailyData: [], //日统计
      monthlyData: [], //月统计
      dayMouth: true,
      firstDay: "",
      lastDay: "",
      firstMonth: "",
      lastMonth: "",
      id: "",
      companyId: "",
      indexDate: {},
      indexDate1: {},
      stateType: {
        1: "停机",
        3: "故障",
        4: "充电",
        5: "放电",
      },
      fx_login_companyType: 0,
      onlineList: ["离线", "在线", "未知"],
      onlineColor: ["red", "#67c23a", "#909399"],
      chargePower: "",
      indexBattery: {},
      bmsModels: [],
      typeNum: 2,
      timeInit: "",
      initTime: true,
      tabList: {
        Home: true,
        BMS: true,
        PCS: true,
        Cell: true,
        Distribute: true,
        voltage: true,
      },
      cabinetCodeId: "",
      flagInstruct: true,
      alarmsState: [
        {
          id: 0,
          value: "过充",
          type: "warning",
        },
        {
          id: 1,
          value: "过放",
          type: "warning",
        },
        {
          id: 2,
          value: "充电过流",
          type: "warning",
        },
        {
          id: 3,
          value: "放电过流",
          type: "warning",
        },
        {
          id: 4,
          value: "绝缘故障",
          type: "danger",
        },
        {
          id: 5,
          value: "过温",
          type: "warning",
        },
        {
          id: 6,
          value: "低温",
          type: "warning",
        },
        {
          id: 7,
          value: "禁充",
          type: "danger",
        },
        {
          id: 8,
          value: "禁放",
          type: "danger",
        },
        {
          id: 9,
          value: "总压过高",
          type: "warning",
        },
        {
          id: 10,
          value: "总压过低",
          type: "warning",
        },
        {
          id: 11,
          value: "BMS故障",
          type: "danger",
        },
        {
          id: 20,
          value: "单体电压过高",
          type: "warning",
        },
        {
          id: 21,
          value: "单体电压过低",
          type: "warning",
        },
        {
          id: 22,
          value: "单体温度过高",
          type: "warning",
        },
      ],
      fl: true,
    };
  },
  watch: {
    activeName() {
      const _this = this;
      if (_this.activeName == "first") {
        _this.timeInit = setInterval(() => {
          _this.initDate();
        }, 8000);
      } else {
        // clearInterval(_this.timeInit);
      }
    },
    initTime() {
      const _this = this;
      _this.timeInit = setInterval(() => {
        _this.initDate();
      }, 8000);
    },
  },
  destroyed() {
    console.log("销毁了");
    const _this = this;
    clearInterval(_this.timeInit);
    this.fl = true;
  },
  mounted() {
    const _this = this;
    _this.fx_login_companyType = localStorage.getItem("fx_login_companyType");
    _this.id = this.$route.query.id || "";
    _this.cabinetCodeId = this.$route.query.cabinetCodes || "";
    _this.companyId = this.$route.query.companyId || "";
    _this.initDate();
    const setTimeouts = setTimeout(() => {
      _this.initTime = false;
      clearTimeout(setTimeouts);
    }, 7000);
    const childrenList = localStorage.getItem("fx_children_list");
    _this.tabList.Home =
      childrenList.indexOf("cabinet_detail") > -1 ? true : false;
    _this.tabList.BMS = childrenList.indexOf("cabinet_bms") > -1 ? true : false;
    _this.tabList.PCS = childrenList.indexOf("cabinet_pcs") > -1 ? true : false;
    _this.tabList.Cell =
      childrenList.indexOf("cabinet_monomer") > -1 ? true : false;
    _this.tabList.Distribute =
      childrenList.indexOf("cabinet_config") > -1 ? true : false;
    this.buttonShow();
  },
  methods: {
    toggleChage() {
      this.$router.push({
        name: "OrderList",
        params: {
          companyId: this.indexDate.companyId,
          cabinetId: this.indexDate.id,
          companyFullName: this.indexDate.companyFullName,
          cabinetCode: this.indexDate.cabinetCode,
        },
      });
    },
    toggleChageR() {
      this.$router.push({
        name: "DailyList",
        params: {
          companyId: this.indexDate.companyId,
          cabinetId: this.indexDate.id,
          companyFullName: this.indexDate.companyFullName,
          cabinetCode: this.indexDate.cabinetCode,
        },
      });
    },
    toggleChageY() {
      this.$router.push({
        name: "MonthlyList",
        params: {
          companyId: this.indexDate.companyId,
          cabinetId: this.indexDate.id,
          companyFullName: this.indexDate.companyFullName,
          cabinetCode: this.indexDate.cabinetCode,
        },
      });
    },
    buttonShow() {
      if (localStorage.getItem("fx_menu_selected_jurisdiction")) {
        let jurisdiction = JSON.parse(
          localStorage.getItem("fx_menu_selected_jurisdiction")
        );
        let obj = jurisdiction[0].children.find(
          (obj) => obj.title === "监控中心"
        );
        let obj1 = obj.children.find((obj) => obj.title === "设备管理");

        let arr = [
          "ViewFeeConfig",
          "WorkStateControl",
          "SetFeeConfig",
          "SetPasswd",
          "ViewPasswd",
        ];
        this.flagInstruct = arr.some((name) => {
          return obj1.resources.some(
            (item) => item.name === name && item.selected
          );
        });
      }
    },
    //bms状态显示
    getAlarmValues(alarms) {
      var alarmState = [];
      alarms.map((alarmId) => {
        alarmState.push(this.alarmsState.find((state) => state.id === alarmId));
      });
      return alarmState;
    },
    chageDayMonth() {
      const _this = this;
      // _this.typeNum = _this.typeNum == "1" ? "2" : "1";
      if (this.chageName == "day") {
        _this.typeNum = 1;
      } else {
        _this.typeNum = 2;
      }
      var _dateFrom = null;
      var _dateTo = null;
      let sendUrl =
        "/cabinet/monitoring/cabinet/v2?cabinetId=" +
        this.id +
        "&type=" +
        _this.typeNum;
      if (_this.chageName == "currentSearch") {
        if (_this.dayMouth) {
          _dateFrom = addDate(new Date(), -12);
          _dateTo = addDate(new Date(), 0);
          if (_this.firstDay) {
            sendUrl += "&dateFrom=" + _this.firstDay.toString().split(",")[0];
            sendUrl += "&dateTo=" + _this.firstDay.toString().split(",")[1];
          } else {
            sendUrl += "&dateFrom=" + _dateFrom;
            sendUrl += "&dateTo=" + _dateTo;
          }
        } else {
          _dateFrom = addMonth(new Date(), -5);
          _dateTo = addMonth(new Date(), 0);
          if (_this.lastMonth) {
            sendUrl += "&dateFrom=" + _this.lastMonth.toString().split(",")[0];
            sendUrl += "&dateTo=" + _this.lastMonth.toString().split(",")[1];
          } else {
            sendUrl += "&dateFrom=" + _dateFrom;
            sendUrl += "&dateTo=" + _dateTo;
          }
        }
      } else {
        sendUrl += "&dateFrom=" + "";
        sendUrl += "&dateTo=" + "";
      }
      AxiosAjax({
        url: sendUrl,
        success: function (res) {
          _this.indexDate = res.data.data || {};
        },
      });
    },
    initDate() {
      const _this = this;
      var _dateFrom = addDate(new Date(), -60);
      var _dateTo = addDate(new Date(), 0);
      let _dateFromTime, _dateToTime;
      // let sendUrlNew =
      //   "/cabinet/monitoring/cabinet/v2?cabinetId=" +
      //   this.id +
      //   "&type=" +
      //   _this.typeNum;
      // if (_this.chageName == "currentSearch") {
      //   if (_this.dayMouth) {
      //     _dateFromTime = addDate(new Date(), -12);
      //     _dateToTime = addDate(new Date(), 0);
      //     if (_this.firstDay) {
      //       sendUrlNew +=
      //         "&dateFrom=" + _this.firstDay.toString().split(",")[0];
      //       sendUrlNew += "&dateTo=" + _this.firstDay.toString().split(",")[1];
      //     } else {
      //       sendUrlNew += "&dateFrom=" + _dateFromTime;
      //       sendUrlNew += "&dateTo=" + _dateToTime;
      //     }
      //   } else {
      //     _dateFromTime = addMonth(new Date(), -5);
      //     _dateToTime = addMonth(new Date(), 0);
      //     if (_this.lastMonth) {
      //       sendUrlNew +=
      //         "&dateFrom=" + _this.lastMonth.toString().split(",")[0];
      //       sendUrlNew += "&dateTo=" + _this.lastMonth.toString().split(",")[1];
      //     } else {
      //       sendUrlNew += "&dateFrom=" + _dateFromTime;
      //       sendUrlNew += "&dateTo=" + _dateToTime;
      //     }
      //   }
      // } else {
      //   sendUrlNew += "&dateFrom=" + "";
      //   sendUrlNew += "&dateTo=" + "";
      // }
      let sendUrlNew = "/cabinet/cabinet/" + this.id;
      AxiosAjax({
        url: sendUrlNew,
        success: function (res) {
          _this.indexDate1 = res.data.data || {};
        },
      });
      this.chageDayMonth();
      AxiosAjax({
        url: "/cabinet/index/" + this.id,
        success: function (res) {
          // 正常 0 ，故障 1
          _this.indexBattery = res.data.data || {};
          _this.bmsModels = res.data.data.bmsmodels || [
            { soc: 0, tag: "BMS #1" },
            { soc: 0, tag: "BMS #2" },
            { soc: 0, tag: "BMS #3" },
            { soc: 0, tag: "BMS #4" },
          ];
          _this.currentTime = res.data.data.deviceTime || "";
        },
      });

      if (this.fl) {
        //日统计
        AxiosAjax({
          url:
            "/cabinet/home/dailyStats/v2?companyId=" +
            this.companyId +
            "&cabinetCode=" +
            this.cabinetCodeId +
            "&dateFrom=" +
            _dateFrom +
            "&dateTo=" +
            _dateTo,
          success: function (res) {
            _this.dailyData = res.data.data;
            _this.initChart();
          },
        });

        _dateFrom = addMonth(new Date(), -5);
        _dateTo = addMonth(new Date(), 0);
        //月统计
        AxiosAjax({
          url:
            "/cabinet/home/monthlyStats/v2?companyId=" +
            this.companyId +
            "&cabinetCode=" +
            this.cabinetCodeId +
            "&dateFrom=" +
            _dateFrom +
            "&dateTo=" +
            _dateTo,
          success: function (res) {
            _this.monthlyData = res.data.data;
            _this.initChart();
          },
        });
        this.fl = false;
      }
    },
    handleClick() {
      if (this.activeName == "first") {
        this.initDate();
      } else {
        this.fl = true;
        clearInterval(this.timeInit);
      }
    },
    chageDayMou() {
      this.dayMouth = !this.dayMouth;
      this.initChart();
    },
    dayMonthSerch() {
      // 搜索
      const _this = this;
      let sendUrl = "";

      if (_this.dayMouth) {
        let _dateFrom = addDate(new Date(), -60);
        let _dateTo = addDate(new Date(), 0);
        sendUrl =
          "/cabinet/home/dailyStats/v2?companyId=" +
          _this.companyId +
          "&cabinetCode=" +
          _this.cabinetCodeId;
        if (_this.firstDay) {
          sendUrl += "&dateFrom=" + _this.firstDay.toString().split(",")[0];
          sendUrl += "&dateTo=" + _this.firstDay.toString().split(",")[1];
        } else {
          sendUrl += "&dateFrom=" + _dateFrom;
          sendUrl += "&dateTo=" + _dateTo;
        }
      } else {
        let _dateFroms = addMonth(new Date(), -5);
        let _dateTos = addMonth(new Date(), 0);
        sendUrl =
          "/cabinet/home/monthlyStats/v2?companyId=" +
          _this.companyId +
          "&cabinetCode=" +
          _this.cabinetCodeId;
        if (_this.lastMonth) {
          sendUrl += "&dateFrom=" + _this.lastMonth.toString().split(",")[0];
          sendUrl += "&dateTo=" + _this.lastMonth.toString().split(",")[1];
        } else {
          sendUrl += "&dateFrom=" + _dateFroms;
          sendUrl += "&dateTo=" + _dateTos;
        }
      }
      AxiosAjax({
        url: sendUrl,
        success: function (res) {
          if (_this.dayMouth) {
            _this.dailyData = res.data.data;
          } else {
            _this.monthlyData = res.data.data;
          }
          _this.initChart();
        },
      });
    },

    //初始化图表
    initChart: function () {
      //处理数据
      let titleDaily = [];
      let titleMonthly = [];

      let dataChargePower = []; //充
      let dataDischargePower = []; //放
      let dataExpenditure = []; //
      let dataIncome = []; //
      let dataProfit = []; //

      this.dailyData.map((item) => {
        titleDaily.push(item.date);
        dataChargePower.push(item.chargePower);
        dataDischargePower.push(item.dischargePower);
        dataExpenditure.push(item.expenditure);
        dataIncome.push(item.income);
        dataProfit.push(item.profit);
      });

      //基于准备好的dom，初始化echarts实例
      let dailyChart = echarts.init(document.getElementById("dailyChart"));
      let monthlyChart = echarts.init(document.getElementById("monthlyChart"));
      this.$nextTick(() => {
        dailyChart.resize();
        monthlyChart.resize();
      });
      this.echartList.push(dailyChart);
      this.echartList.push(monthlyChart);

      var optionDaily = {
        color: ["#3398DB"],
        title: {
          text: "日统计数据",
          subtext: "",
          textStyle: { fontSize: 16, fontWeight: "normal", color: "#000" },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        xAxis: {
          data: titleDaily,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "充电",
            type: "line",
            data: dataChargePower,
            itemStyle: {
              normal: {
                color: "#00aa00", //改变折线点的颜色
                lineStyle: {
                  color: "#00aa00", //改变折线颜色
                },
              },
            },
          },
          {
            name: "放电",
            type: "line",
            data: dataDischargePower,
            itemStyle: {
              normal: {
                color: "#0055ff", //改变折线点的颜色
                lineStyle: {
                  color: "#0055ff", //改变折线颜色
                },
              },
            },
          },
          {
            name: "成本",
            type: "line",
            data: dataExpenditure,
            itemStyle: {
              normal: {
                color: "#5555ff", //改变折线点的颜色
                lineStyle: {
                  color: "#5555ff", //改变折线颜色
                },
              },
            },
          },
          {
            name: "收入",
            type: "line",
            data: dataIncome,
            itemStyle: {
              normal: {
                color: "#555500", //改变折线点的颜色
                lineStyle: {
                  color: "#555500", //改变折线颜色
                },
              },
            },
          },
          {
            name: "利润",
            type: "line",
            data: dataProfit,
            itemStyle: {
              normal: {
                color: "#ff0000", //改变折线点的颜色
                lineStyle: {
                  color: "#ff0000", //改变折线颜色
                },
              },
            },
          },
        ],
      };

      var optionDailyCustomer = {
        color: ["#3398DB"],
        title: {
          text: "日统计数据",
          subtext: "",
          textStyle: { fontSize: 16, fontWeight: "normal", color: "#000" },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        xAxis: {
          data: titleDaily,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "充电",
            type: "line",
            data: dataChargePower,
            itemStyle: {
              normal: {
                color: "#00aa00", //改变折线点的颜色
                lineStyle: {
                  color: "#00aa00", //改变折线颜色
                },
              },
            },
          },
          {
            name: "放电",
            type: "line",
            data: dataDischargePower,
            itemStyle: {
              normal: {
                color: "#0055ff", //改变折线点的颜色
                lineStyle: {
                  color: "#0055ff", //改变折线颜色
                },
              },
            },
          },
        ],
      };

      // if (this.isShow) {
      //绘制图表
      // dailyChart.setOption(optionDaily);
      // } else {
      //   //绘制图表
      dailyChart.setOption(optionDailyCustomer);
      // }

      dataChargePower = []; //充
      dataDischargePower = []; //放
      dataExpenditure = []; //
      dataIncome = []; //
      dataProfit = []; //

      this.monthlyData.map((item) => {
        titleMonthly.push(item.date);
        dataChargePower.push(item.chargePower);
        dataDischargePower.push(item.dischargePower);
        dataExpenditure.push(item.expenditure);
        dataIncome.push(item.income);
        dataProfit.push(item.profit);
      });

      var optionMonthly = {
        color: ["#3398DB"],
        title: {
          text: "月统计数据",
          subtext: "",
          textStyle: { fontSize: 16, fontWeight: "normal", color: "#000" },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        xAxis: {
          data: titleMonthly,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "充电",
            type: "line",
            data: dataChargePower,
            itemStyle: {
              normal: {
                color: "#00aa00", //改变折线点的颜色
                lineStyle: {
                  color: "#00aa00", //改变折线颜色
                },
              },
            },
          },
          {
            name: "放电",
            type: "line",
            data: dataDischargePower,
            itemStyle: {
              normal: {
                color: "#0055ff", //改变折线点的颜色
                lineStyle: {
                  color: "#0055ff", //改变折线颜色
                },
              },
            },
          },
          {
            name: "成本",
            type: "line",
            data: dataExpenditure,
            itemStyle: {
              normal: {
                color: "#5555ff", //改变折线点的颜色
                lineStyle: {
                  color: "#5555ff", //改变折线颜色
                },
              },
            },
          },
          {
            name: "收入",
            type: "line",
            data: dataIncome,
            itemStyle: {
              normal: {
                color: "#555500", //改变折线点的颜色
                lineStyle: {
                  color: "#555500", //改变折线颜色
                },
              },
            },
          },
          {
            name: "利润",
            type: "line",
            data: dataProfit,
            itemStyle: {
              normal: {
                color: "#ff0000", //改变折线点的颜色
                lineStyle: {
                  color: "#ff0000", //改变折线颜色
                },
              },
            },
          },
        ],
      };

      var optionMonthlyCustomer = {
        color: ["#3398DB"],
        title: {
          text: "月统计数据",
          subtext: "",
          textStyle: { fontSize: 16, fontWeight: "normal", color: "#000" },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        xAxis: {
          data: titleMonthly,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "充电",
            type: "line",
            data: dataChargePower,
            itemStyle: {
              normal: {
                color: "#00aa00", //改变折线点的颜色
                lineStyle: {
                  color: "#00aa00", //改变折线颜色
                },
              },
            },
          },
          {
            name: "放电",
            type: "line",
            data: dataDischargePower,
            itemStyle: {
              normal: {
                color: "#0055ff", //改变折线点的颜色
                lineStyle: {
                  color: "#0055ff", //改变折线颜色
                },
              },
            },
          },
        ],
      };

      // if (this.isShow) {
      //绘制图表
      // monthlyChart.setOption(optionMonthly);
      // } else {
      //   //绘制图表
      monthlyChart.setOption(optionMonthlyCustomer);
      // }
    },
  },
};
</script>
<style scoped>
.current_time_tabs /deep/ .el-tabs__content {
  overflow: inherit;
}
.current_time {
  position: absolute;
  right: 16px;
  top: -26px;
}
.card_padding /deep/ .el-card__body {
  padding: 10px 20px;
}
.tabs_day_mounth /deep/ .el-tabs__header {
  margin-bottom: 0;
}
.main_tabs /deep/ .el-tabs__content,
.main_tabs /deep/ .el-tabs {
  max-width: 1220px;
  margin: 0 auto;
}

.soc_schedule {
  display: inline-block;
  width: 150px;
  height: 12px;
  background: #ccc;
}
.soc_schedule p {
  background: yellowgreen;
  height: 12px;
}
.main_tabs /deep/ .el-tabs--card > .el-tabs__header {
  margin: 0 10px;
}
.card_div_margin {
  position: relative;
}
.details_infor_left .card_div_margin > p {
  margin-bottom: 14px;
}
.schedule {
  display: inline-block;
  width: 150px;
  height: 10px;
  background: #ccc;
}

.schedule1 {
  display: inline-block;
  width: 150px;
  height: 10px;
  background: yellow;
}

.battery li {
  margin: 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
}
.schedule > p {
  width: 70%;
  background: yellowgreen;
  height: 100%;
}
.details_infor_left .card_margin_bottom {
  text-align: left;
  padding: 10px 20px;
}
.card_status {
  padding: 4px 10px;
  background: #ccc;
  border-radius: 4px;
  color: #fff;
}
.crad_status_circle {
  position: absolute;
  top: 0px;
  right: 10px;
  padding: 8px;
  background: #ccc;
  border-radius: 50%;
}
.card_margin_bottom {
  margin-bottom: 10px;
}
.mainbody {
  display: flex;
}
.details_infor_left {
  flex: 1;
  margin: 10px;
  min-width: 350px;
}
.details_infor_right {
  flex: 2;
  margin: 10px 10px 10px 0;
}
.chage_day_month {
  text-align: left;
}
.day_month_span {
  background: #267cb7;
  color: #fff;
  display: inline-block;
  height: 38px;
  line-height: 38px;
  margin-right: -6px;
  padding: 0 10px;
}
.day_month_span_click {
  cursor: pointer;
}
.day_month_span_serch {
  cursor: pointer;
  margin-left: 16px;
}
.statistics {
  border: 1px solid #ccc;
  margin-top: 20px;
  border-bottom: 0;
}
.statistics li {
  border-bottom: 1px solid #ccc;
  display: flex;
  height: 30px;
  line-height: 30px;
}
.statistics li > span {
  flex: 1;
}
.card_bg_1 {
  background: url(../../assets/ChargeMode_00.gif) no-repeat;
  background-size: 822px 500px;
  background-position: 50% 50%;
}
.card_bg_2 {
  background: url(../../assets/ChargeMode_01.gif) no-repeat;
  background-size: 822px 500px;
  background-position: 50% 50%;
}
.card_bg_3 {
  background: url(../../assets/ChargeMode_1.gif) no-repeat;
  background-size: 822px 500px;
  background-position: 50% 50%;
}
.card_bg_4 {
  background: url(../../assets/ChargeMode_2.gif) no-repeat;
  background-size: 822px 500px;
  background-position: 50% 50%;
}
.details_infor_right .card_pic /deep/ .el-card__body {
  position: relative;
  min-height: 460px;
}
.card_pic span {
  position: absolute;
  z-index: 10;
  width: 200px;
  height: 100px;
  text-align: left;
  font-size: 12px;
  line-height: 20px;
}
.card_pic span i {
  display: inline-block;
  width: 16px;
  height: 16px;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  color: #fff;
}
.card_pic span /deep/ .el-icon-close {
  background: red;
}
.card_pic span /deep/ .el-icon-check {
  background: yellowgreen;
}
.span_pic_1 {
  top: 10px;
  left: calc(50% - 340px);
}
.span_pic_2 {
  top: 10px;
  left: 50%;
}
.span_pic_3 {
  top: 10px;
  left: calc(50% + 230px);
}
.span_pic_4 {
  left: calc(50% + 170px);
  bottom: -40px;
}
.span_pic_5 {
  left: calc(50% - 280px);
  bottom: 40px;
}
.font_w600 {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/Monitor/CabinetDetails.vue